import { FC, useMemo } from "react";
import { wafflesKeyColumnName } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { ColumnConfig, TextAlignment, WafflesThemes } from "@app/shared/waffles/exports";
import { CountyStatusData } from "../interfaces";

interface CountyStatusTableData {
  [wafflesKeyColumnName]: string;
  counties: string;
  fillableGaps: string;
  gaps: string;
  status: string;
}

const columnConfig: ColumnConfig = {
  counties: {
    alignment: TextAlignment.Right,
    displayText: "Counties",
    noSort: true,
    testId: "counties",
  },
  fillableGaps: {
    alignment: TextAlignment.Right,
    displayElement: <>Composite<br />Fillable Gaps</>,
    noSort: true,
    testId: "fillable-gaps",
    tooltip: "",
  },
  gapPercent: {
    alignment: TextAlignment.Right,
    displayText: "Gap Percent",
    noSort: true,
    testId: "gap-percent",
  },
  gaps: {
    alignment: TextAlignment.Right,
    displayText: "Gaps",
    noSort: true,
    testId: "gaps",
  },
  medianGapAge: {
    alignment: TextAlignment.Right,
    displayElement: <>Median<br />Gap Age Days</>,
    noSort: true,
    testId: "median-gap-age",
    // displayElement defaults to the displayText/key for a tooltip, but we don't want it
    tooltip: "",
  },
  status: {
    alignment: TextAlignment.Left,
    displayText: "Status",
    noSort: true,
    testId: "status",
  }
};

interface CountyStatusTableProps {
  tableData: CountyStatusData[];
}

const CountyStatusTable: FC<CountyStatusTableProps> = (props: CountyStatusTableProps) => {

  /* oxlint-disable sort-keys */
  const tableRows: CountyStatusTableData[] = useMemo(() => {
    return (props.tableData || []).map((status) => {
      return {
        [wafflesKeyColumnName]: status.countyStatus,
        status: status.countyStatus,
        counties: status.countyCount.toLocaleString(),
        gaps: status.gapCount.toLocaleString(),
        fillableGaps: status.compositeFillableGapCount.toLocaleString(),
        medianGapAge: status.medianGapAge.toLocaleString(),
        gapPercent: `${status.gapPercent.toLocaleString()}%`,
      };
    });
  }, [props.tableData]);
  /* oxlint-enable */

  const rowDecorator = (row: CountyStatusTableData) => {
    if (row.status === "Total") {
      // return "footer footer--border-bottom";
      return "footer";
    }
  }

  return (
    <div className="qes-dashboard-tile__table">
      <Waffles<CountyStatusTableData>
        columns={columnConfig}
        data={tableRows}
        disableStickyHeader={true}
        fullWidth={true}
        keyColumns={["status"]}
        loading={!props.tableData}
        rowDecorator={rowDecorator}
        testId="county-status-overview"
        theme={WafflesThemes.Simple}
      />
    </div>
  )
}

export default CountyStatusTable;